// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import './registerServiceWorker'

import router from './router'
import './output.css'
import './styles/mobile-navbar.css'
import './styles/animations.css'
import store from './vuex'
import axios from 'axios'
// 引用API文件
import api from './api/index'
// vuex
import '@/vuex/index' // 全局
import {hasPermission} from './promission.js' // 路由后台获取
import message from "@/components/index"
import { getLocaleState, initAppLocale, setAppLocale, t as translate } from './utils/i18n'
// Custom lazy loading directive using Intersection Observer with skeleton
Vue.directive('lazy', {
  inserted: function (el, binding) {
    const imageUrl = binding.value
    const errorImg = '/static/dist/img/album_null.jpg'
    
    // Create skeleton wrapper
    const wrapper = document.createElement('div')
    wrapper.className = 'relative inline-block'
    
    // Copy original element's computed styles
    const computedStyle = window.getComputedStyle(el)
    wrapper.style.width = computedStyle.width === 'auto' ? el.offsetWidth + 'px' : computedStyle.width
    wrapper.style.height = computedStyle.height === 'auto' ? el.offsetHeight + 'px' : computedStyle.height
    wrapper.style.maxWidth = computedStyle.maxWidth
    wrapper.style.maxHeight = computedStyle.maxHeight
    wrapper.style.minWidth = computedStyle.minWidth
    wrapper.style.minHeight = computedStyle.minHeight
    
    // Create skeleton element
    const skeleton = document.createElement('div')
    skeleton.className = 'skeleton h-full w-full absolute inset-0 rounded'
    
    // Insert wrapper before original element
    el.parentNode.insertBefore(wrapper, el)
    wrapper.appendChild(skeleton)
    wrapper.appendChild(el)
    
    // Style the image
    el.className = el.className + ' absolute inset-0 w-full h-full object-cover rounded opacity-0 transition-opacity duration-300'
    // Prevent touch interactions from affecting opacity
    el.style.webkitTouchCallout = 'none'
    el.style.webkitUserSelect = 'none'
    el.style.userSelect = 'none'
    
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const wrapper = entry.target
            const img = wrapper.querySelector('img')
            const skeleton = wrapper.querySelector('.skeleton')
            
            img.src = imageUrl
            img.onload = () => {
              img.classList.add('opacity-100')
              img.classList.remove('opacity-0')
              // Ensure opacity stays at 1 even during touch events
              img.style.opacity = '1'
              img.style.setProperty('opacity', '1', 'important')
              skeleton.style.display = 'none'
            }
            img.onerror = (err) => {
              // img.src = errorImg
              img.classList.add('opacity-100')
              img.classList.remove('opacity-0')
              // Ensure opacity stays at 1 even during touch events
              img.style.opacity = '1'
              img.style.setProperty('opacity', '1', 'important')
              skeleton.style.display = 'none'
            }
            observer.unobserve(wrapper)
          }
        })
      },
      {
        rootMargin: '50px'
      }
    )
    
    observer.observe(wrapper)
  }
})
Vue.use(message.register);
Vue.use(axios)
// 将API方法绑定到全局
Vue.prototype.$http = axios
Vue.prototype.$api = api
const headTheme = 'light' // 选择 light 或 blue
Vue.prototype.headTheme = headTheme
// Vue.prototype.$lodash = lodash
Vue.prototype.hasPerm = hasPermission
Vue.config.productionTip = false
const localeState = getLocaleState()
initAppLocale()
Vue.prototype.$localeState = localeState
Vue.prototype.$setLocale = setAppLocale
Vue.prototype.$tt = function(key, params) {
  return translate(key, params)
}
// Vue.prototype.cloneDeep = function(data) {
//     return lodash.cloneDeep(data)
// }
Vue.prototype.setCookie = function(name, value, days) {
  try {
    // 先删除已存在的同名 cookie
    const existingCookie = this.getCookie(name)
    if (existingCookie) {
      document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/'
    }
    
    let cookieString = name + '=' + encodeURIComponent(value) + ';path=/'
    
    if (days && days > 0) {
      const date = new Date()
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000))
      cookieString += ';expires=' + date.toUTCString()
    }
    
    // 为了兼容现代浏览器的安全要求，添加SameSite属性
    cookieString += ';SameSite=Lax'
    
    document.cookie = cookieString
  } catch (error) {
    console.error('设置Cookie失败:', error)
  }
}
Vue.prototype.getCookie = function(name) {
  try {
    const cookies = document.cookie.split(';')
    
    for (let cookie of cookies) {
      const [cookieName, cookieValue] = cookie.trim().split('=')
      if (cookieName === name) {
        return decodeURIComponent(cookieValue || '')
      }
    }
    
    return null
  } catch (error) {
    console.error('获取Cookie失败:', error)
    return null
  }
}
Vue.prototype.formatDate = function (dateString) {
    const formattedDate = dateString.replace(/T/, ' ').replace(/\.000Z/, '');
    return formattedDate
}
/* eslint-disable no-new */
const vue = new Vue({
  el: '#app',
  router,
  store,
  components: {App},
  data() {
    return {
      website: '我是全局变量'
    }
  },
  template: '<App/>'
})
export default vue
